import axios from "axios"
const route = 'budget/service'
const BudgetService = {
   namespaced: true,

   state: () => ({
      dialogNewComposition: false
   }),

   getters: {

   },

   mutations: {

   },
   actions: {
    deleteCompositionService(context,data){
        return axios.post(route + '/delete_composition_service',data)
    }
   }


}


export default BudgetService
